module.exports = __webpack_public_path__ + "img/plany_rb_bg.720de5d6.png";